import bill from "@app/assets/images/logos/bill-com.svg";
import brex from "@app/assets/images/logos/brex.svg";
import chargebee from "@app/assets/images/logos/chargebee.svg";
import deel from "@app/assets/images/logos/deel.svg";
import gusto from "@app/assets/images/logos/gusto.svg";
import mercury from "@app/assets/images/logos/mercury.svg";
import paddle from "@app/assets/images/logos/paddle.svg";
import paypal from "@app/assets/images/logos/paypal.svg";
import quickbooks from "@app/assets/images/logos/quickbooks.svg";
import ramp from "@app/assets/images/logos/ramp.svg";
import revolut from "@app/assets/images/logos/revolut.svg";
import rippling from "@app/assets/images/logos/rippling.svg";
import sage from "@app/assets/images/logos/sage.svg";
import shopify from "@app/assets/images/logos/shopify.svg";
import spreadsheets from "@app/assets/images/logos/spreadsheets.svg";
import square from "@app/assets/images/logos/square.svg";
import stripe from "@app/assets/images/logos/stripe.svg";
import chase from "@app/assets/images/logos/us-chase.svg";
import wise from "@app/assets/images/logos/wise.svg";
import xero from "@app/assets/images/logos/xero.svg";

// The mark on a stack card and on its collection-hub card, by the stack
// option's id. Each is the brand's own mark in the brand's own colours, drawn
// as a full-bleed app-icon square so twenty different companies sit together
// as one set; the <img> rounds the corners. Spreadsheets is not a company, so
// it gets a plain grid rather than somebody else's logo.
//
// An id with no entry keeps the grey square.
export const LOGOS: Record<string, string> = {
  QUICKBOOKS: quickbooks,
  XERO: xero,
  SAGE: sage,
  STRIPE: stripe,
  SHOPIFY: shopify,
  PAYPAL: paypal,
  SQUARE: square,
  PADDLE: paddle,
  CHARGEBEE: chargebee,
  US_CHASE: chase,
  MERCURY: mercury,
  REVOLUT: revolut,
  BREX: brex,
  RAMP: ramp,
  WISE: wise,
  GUSTO: gusto,
  RIPPLING: rippling,
  DEEL: deel,
  BILL_COM: bill,
  SPREADSHEETS: spreadsheets,
};
